export enum CsOperationGroupTypes {
  balance = 'groupTypes.balance',
  reserve = 'groupTypes.reserve',
  spent = 'groupTypes.spent',
  transfer = "groupTypes.transfer"
}
